import Vue from 'vue';
import { D3BarChart } from 'vue-d3-charts';

Vue.component('D3BarChart', D3BarChart);
